export default "__VITE_ASSET__fdad33ff__"